__turbopack_context__.v({
  "display-name": "_9QX9Ka_display-name",
  "variants": "_9QX9Ka_variants",
});
